import { render, staticRenderFns } from "./FramedImage.vue?vue&type=template&id=7caee64d&"
import script from "./FramedImage.vue?vue&type=script&lang=js&"
export * from "./FramedImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports